import { useEffect, useState } from "react";
import { useStore } from "../state/store";

interface Props {
  /** Server-clock deadline. */
  deadline: number;
  total: number;
  width?: number | string;
  height: number;
  showSeconds?: boolean;
  onTick?: (msLeft: number) => void;
}

/** Yellow bar draining right to left until the server deadline. */
export function TimerBar({ deadline, total, width = "100%", height, showSeconds, onTick }: Props) {
  const offset = useStore((s) => s.clockOffset);
  const [left, setLeft] = useState(() => deadline - (Date.now() + offset));

  useEffect(() => {
    let frame = 0;
    const tick = () => {
      const ms = Math.max(0, deadline - (Date.now() + offset));
      setLeft(ms);
      onTick?.(ms);
      if (ms > 0) frame = requestAnimationFrame(tick);
    };
    tick();
    return () => cancelAnimationFrame(frame);
  }, [deadline, offset, onTick]);

  const pct = Math.max(0, Math.min(1, left / total)) * 100;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, width }}>
      <div
        style={{
          flex: 1,
          height,
          borderRadius: height / 2,
          background: "var(--track)",
          overflow: "hidden",
        }}
      >
        <div style={{ width: `${pct}%`, height, background: "var(--timer)" }} />
      </div>
      {showSeconds && (
        <div style={{ fontSize: 14, fontWeight: 700, color: "var(--timer)", minWidth: 24 }}>
          {Math.ceil(left / 1000)} s
        </div>
      )}
    </div>
  );
}
